import { defaultWebsiteId } from '@va/constants';

export const getInstanceId = (state: any) => {
  const instanceId = state.getIn(['core', 'app', 'instanceId']);
  return instanceId ?? defaultWebsiteId;
};
